import { StoreState } from '@store'

export const parseAnswers = (
  questions: QuestionDataInput[],
  answersPreset: Record<keyof StoreState, any>
): Record<string, any> => {
  const response: Record<string, any> = {}

  questions.forEach(({ key }) => {
    let value

    if (key === 'date_of_birth') {
      const {
        dob_month,
        dob_day,
        dob_year,
      } = answersPreset
      if (dob_month && dob_day && dob_year) {
        const month = dob_month.length === 2 ? dob_month : `0${dob_month}`
        const day = dob_day.length === 2 ? dob_day : `0${dob_day}`
        value = `${month}/${day}/${dob_year}`
      }
    } else {
      value = answersPreset[key]
    }

    response[key] = value
  })

  return response
}

export const extractAnswers = (
  answers: Record<string, any>
): Record<keyof StoreState, any> => {
  const currentAnswers: Record<string, any> = { ...answers }
  const birthdayInput = currentAnswers['date_of_birth']

  if (birthdayInput) {
    const [dob_month, dob_day, dob_year] = birthdayInput.split('/')
    delete currentAnswers.date_of_birth

    return {
      ...currentAnswers as Record<keyof StoreState, any>,
      dob_month,
      dob_day,
      dob_year
    }
  } else {
    return currentAnswers
  }
}
